import React, { useState, useEffect } from 'react';
import { translations } from '../Text/translations';
import hbomaxAppLogo from '../../assets/max/hbomax-applogo.png';
import hbomaxDevices from '../../assets/max/hbomax-devices.png';

const MaxActivated = ({ currentLang, nickname, mobilenowid, emailnowid }) => {
  const handleLogonButtonClick = () => {
    window.location.href = 'http://nowplayer.now.com';
  };

  const handleSupportedDevicesClick = () => {
    const url = currentLang === 'en'
      ? 'https://help.hbomax.com/hk-en/Answer/Detail/000002506'
      : 'https://help.hbomax.com/hk/Answer/Detail/000002506';
    window.open(url, '_blank');
  };
  return (
    <>
      <div className="name">
        <h2 className="name">{translations[currentLang].maxSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].maxSubjectGreeting2}</h2>
      </div>

      <div className="message">
        <p>{translations[currentLang].maxActivated}</p>
      </div>
      <div className="cta-buttons">
        <button className="btn primary" onClick={handleLogonButtonClick}>
          {translations[currentLang].backToHome}
        </button>
      </div>

      <div className="dlhbomax-wrapper">
        <div className="app">
          <img src={hbomaxAppLogo} alt="" />
          <h4>{translations[currentLang].maxDownloadAndWatch}</h4>
        </div>
        <p>{translations[currentLang].maxAvailableDevices}</p>
        <img src={hbomaxDevices} alt="" className="img-devices" />
        <a onClick={handleSupportedDevicesClick} className="link new-window">{translations[currentLang].maxDetailOnSupportedDevices}</a>
        <small>{translations[currentLang].maxSmallNote}</small>
      </div>
    </>
  );
};

export default MaxActivated;